import axios from 'axios'

import { getAuthHeader } from 'util/auth'

const client = axios.create({
  baseURL: process.env.REACT_APP_BASE_API_URL,
  contentType: 'application/json',
  headers: {
    'Content-Type': 'application/json',
  },
  transformRequest: [
    function (data, headers) {
      const auth = getAuthHeader()
      if (auth) headers['Authorization'] = auth
      return JSON.stringify(data)
    }
  ],
})

export default client
